import { Injectable } from '@angular/core'
import { MbProductTabSpecificationsAdapter } from './mb-product-tab-specifications.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbProductTabSpecificationsConnector {

  constructor (protected adapter: MbProductTabSpecificationsAdapter) {
  }

  get (productCode: string, maxCount?: number) {
    return this.adapter.load(productCode, maxCount)
  }
}
